export const categories = [
  {
    id: 'gonglue',
    name: '游戏攻略',
    icon: 'ri-sword-line',
    description: '征途国际最新游戏攻略，助你快速提升战力',
  },
  {
    id: 'xinwen',
    name: '新闻资讯',
    icon: 'ri-newspaper-line',
    description: '征途国际最新动态、版本更新、活动公告',
  },
  {
    id: 'gonggao',
    name: '官方公告',
    icon: 'ri-megaphone-line',
    description: '征途国际官方维护通知、合服公告、赛事安排',
  },
  {
    id: 'shipin',
    name: '视频专区',
    icon: 'ri-vidicon-line',
    description: '征途国际精彩战斗视频、主播解说、教学视频',
  },
];

export const articles = [
  {
    id: 1,
    slug: 'xinshou-ru-men-gonglue-2026',
    title: '征途国际2026新手入门全攻略：从零开始征战天下',
    excerpt: '刚踏入征途国际的世界？这篇全面新手攻略将带你快速上手，从角色创建到职业选择，从基础操作到进阶技巧，一站式掌握所有入门知识。',
    content: `征途国际作为一款经典的国战MMORPG手游，凭借其宏大的世界观、热血的万人国战玩法，吸引了无数玩家。如果你是刚刚踏入这片大陆的新手，这篇攻略将帮助你快速上手。

## 一、角色创建与职业选择

征途国际目前提供五大经典职业：

**战士**：近战物理输出，血厚防高，是团队中的前排坦克。适合喜欢冲锋陷阵的玩家。

**法师**：远程魔法输出，拥有强大的AOE伤害技能，但身板较脆。适合喜欢高爆发输出的玩家。

**弓手**：远程物理输出，机动性强，单体爆发高。适合喜欢风筝打法的玩家。

**仙术**：治疗辅助职业，能为队友提供治疗和增益效果。团队中不可或缺的角色。

**召唤**：能够召唤宠物协助战斗，既能输出又能辅助。适合喜欢多样化玩法的玩家。

新手推荐选择战士或仙术，前者容错率高，后者组队需求大。

## 二、快速升级路线

1. **主线任务（1-30级）**：紧跟主线任务走，这是最快的升级方式。主线任务不仅经验丰富，还会赠送大量基础装备。

2. **日常任务（30-50级）**：每日必做的日常任务包括：运镖、刺探、搬砖、国战日常。这些任务经验奖励丰厚。

3. **副本挑战（50级以上）**：组队挑战各类副本，不仅可以获得大量经验，还能掉落珍稀装备。

4. **国战活动**：参与每日国战是升级的重要途径，击杀敌国玩家和占领据点都有丰厚奖励。

## 三、装备获取与强化

装备是提升战斗力的核心。获取途径包括：副本掉落、BOSS击杀、活动兑换、商城购买。建议优先完成每日副本，积累材料逐步强化装备。

## 四、帮派系统

到达30级后即可加入帮派。加入一个活跃的帮派非常重要：帮派任务提供额外经验、帮派商店可购买稀有道具、帮派战可获得丰厚奖励。

## 五、常见问题

Q：征途国际是免费游戏吗？
A：是的，征途国际完全免费下载和游玩。

Q：iOS和安卓数据互通吗？
A：目前iOS和安卓服务器是独立的，但官方正在筹备互通计划。`,
    category: 'gonglue',
    author: '征途攻略组',
    date: '2026-08-10',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20MMORPG%20fantasy%20game%20art%2C%20ancient%20Chinese%20warrior%20in%20dynamic%20battle%20pose%20with%20golden%20armor%2C%20dramatic%20lighting%2C%20cinematic%20game%20illustration%20style%2C%20warm%20red%20and%20gold%20tones%2C%20atmospheric%20battlefield%20background%20with%20flying%20banners%2C%20high%20detail%20digital%20art&width=800&height=450&seq=article-guide-01&orientation=landscape',
  },
  {
    id: 2,
    slug: 'zhiye-pk-2026-paiming',
    title: '征途国际2026职业强度排名：五大职业PVP实力解析',
    excerpt: '深度分析征途国际五大职业在当前版本的PVP表现，从单挑、团战、生存能力等多维度进行排名，帮你选择最适合的PK职业。',
    content: `在征途国际中，PVP是游戏的核心玩法之一。不同职业在PK中的表现差异巨大，本文将为你详细解析各职业的PVP实力。

## S级职业

**法师**：当前版本法师在团战中表现极为出色。强大的AOE技能可以在国战中造成成吨伤害。配合闪现技能，操作娴熟的法师很难被击杀。在1v1中，法师的控制链也让近战职业头疼不已。

## A级职业

**弓手**：单体爆发最高的职业，暴击流的弓手可以在几秒内秒杀脆皮。超远的攻击距离让弓手在团战中有着极佳的输出环境。缺点是身板脆，被近身容易暴毙。

**战士**：最全面的职业，能抗能打。在1v1中，战士凭借冲锋和控制技能可以压制大部分职业。在团战中作为前排，是不可或缺的肉盾。

## B级职业

**仙术**：纯辅助职业，在1v1中较弱。但在团战中的作用无可替代，一个优秀的仙术可以扭转整个战局。适合喜欢团队合作的玩家。

**召唤**：灵活性最高的职业，通过不同的召唤兽搭配可以应对各种场景。但在高强度的PVP中，召唤兽容易被秒杀，导致输出大打折扣。

## 总结

如果你追求团战输出，选法师；喜欢单挑秒人，选弓手；想要全面均衡，选战士。每个职业都有自己的特色和乐趣，选择最适合自己玩法的才是最好的。`,
    category: 'gonglue',
    author: '战力研究院',
    date: '2026-08-08',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20MMORPG%20characters%20facing%20off%20in%20epic%20battle%2C%20five%20different%20classes%20warrior%20mage%20archer%20in%20dramatic%20combat%20poses%2C%20golden%20and%20crimson%20color%20scheme%2C%20cinematic%20lighting%2C%20game%20concept%20art%20style%2C%20ancient%20Chinese%20aesthetic&width=800&height=450&seq=article-pvp-02&orientation=landscape',
  },
  {
    id: 3,
    slug: 'v8-banben-gengxin-gonggao',
    title: '征途国际V8.0版本更新公告：全新跨服战场即将开启',
    excerpt: '征途国际迎来V8.0重大版本更新！全新跨服战场系统、职业平衡调整、装备觉醒系统等海量内容即将上线，敬请期待。',
    content: `亲爱的征途国际玩家：

征途国际将于2026年8月20日进行V8.0版本更新维护。本次更新将带来全新的跨服战场系统和大量游戏优化。

## 更新内容

### 一、全新跨服战场「龙城争霸」
跨服战场是全服玩家同台竞技的全新PVP玩法。每周六晚8点开启，所有服务器玩家可自由组队参与。占领龙城据点的帮派将获得丰厚奖励和专属称号。

### 二、装备觉醒系统
新增装备觉醒功能，消耗觉醒石可为装备激活额外属性。觉醒后的装备将获得独特的特效光效，彰显你的强者身份。

### 三、职业平衡调整
- 法师：略微下调火墙术的持续伤害
- 战士：提升冲锋技能的眩晕时间
- 弓手：优化技能动画，提升操作手感
- 仙术：新增群体净化技能
- 召唤：提升召唤兽的基础生命值

### 四、其他优化
- 优化游戏性能，降低低端设备卡顿
- 新增30套时装外观
- 背包容量扩展至500格
- 修复若干已知BUG

## 维护时间
2026年8月20日 02:00 - 08:00（预计6小时）

维护期间将无法登录游戏，请各位玩家提前做好准备。维护完成后将发放补偿礼包。

征途国际运营团队
2026年8月10日`,
    category: 'gonggao',
    author: '征途运营团队',
    date: '2026-08-10',
    readTime: '4分钟',
    image: 'https://readdy.ai/api/search-image?query=Grand%20Chinese%20fantasy%20game%20update%20announcement%20visual%2C%20ancient%20Chinese%20dragon%20city%20floating%20in%20the%20sky%2C%20epic%20cinematic%20illustration%2C%20warm%20red%20and%20gold%20color%20palette%2C%20dramatic%20clouds%20and%20light%20rays%2C%20game%20promotional%20art%20style&width=800&height=450&seq=article-update-03&orientation=landscape',
  },
  {
    id: 4,
    slug: 'bangpai-zhan-jinqian-miji',
    title: '帮派战进阶秘籍：如何带领帮派走向巅峰',
    excerpt: '帮派战是征途国际最核心的团队玩法之一。本文将从战术布局、人员配置、资源管理三个维度，教你如何打造一支无敌帮派。',
    content: `帮派战是征途国际中最考验团队协作的玩法。一个强大的帮派不仅需要高战力的成员，更需要精妙的战术布局。

## 一、战前准备

**人员配置**：每场帮派战最多出战50人。建议配置：5名指挥、15名前排战士、20名输出（法师+弓手）、10名仙术治疗。

**装备检查**：确保所有出战成员的装备耐久度满值，药水充足。战前30分钟开启帮派BUFF。

**情报收集**：提前了解对手帮派的战力分布、常用战术、核心成员信息。

## 二、核心战术

**分路推进**：将50人分为三路——主力中路30人、分路各10人。主力负责正面推进，分路从侧翼包抄。

**集火指挥**：由总指挥标记优先击杀目标，全团集火秒杀敌方核心输出或治疗。击杀顺序：仙术 > 法师 > 弓手 > 战士 > 召唤。

**资源争夺**：帮派战中地图中央的Buff神符至关重要。安排机动性最强的弓手负责抢夺。

## 三、沟通协作

使用游戏内置语音或第三方语音工具保持实时沟通。每个小队长负责执行总指挥的指令并反馈战场情况。

## 四、战后复盘

每次帮派战后，花15分钟进行复盘。分析胜利的关键因素或失败的原因，持续优化战术。`,
    category: 'gonglue',
    author: '征途攻略组',
    date: '2026-08-05',
    readTime: '7分钟',
    image: 'https://readdy.ai/api/search-image?query=Massive%20scale%20Chinese%20MMORPG%20guild%20war%20battle%20scene%2C%20hundreds%20of%20armored%20warriors%20clashing%20on%20ancient%20battlefield%2C%20epic%20cinematic%20composition%2C%20warm%20golden%20and%20red%20lighting%2C%20dramatic%20war%20banners%20and%20flags%2C%20game%20illustration%20style&width=800&height=450&seq=article-guild-04&orientation=landscape',
  },
  {
    id: 5,
    slug: 'xiari-qingdian-huodong-lai-xi',
    title: '征途国际夏日庆典活动来袭：限定时装免费领',
    excerpt: '为庆祝夏日庆典，征途国际推出系列福利活动！登录即送限定时装、双倍经验狂欢、稀有道具大放送，不容错过。',
    content: `炎炎夏日，征途国际为各位玩家准备了丰厚的庆典福利！即日起至8月31日，登录游戏即可参与系列活动。

## 活动一：登录有礼

活动期间，每日登录游戏即可领取签到奖励。连续签到7天可获得限定时装「盛夏海滨」套装。

## 活动二：双倍经验狂欢

每日18:00-22:00开启全服双倍经验，助你快速升级。周末更有三倍经验加成。

## 活动三：夏日BOSS挑战

活动期间，每日14:00和20:00将在王城刷新夏日限定BOSS，击杀后可获得大量稀有道具和限定称号。

## 活动四：充值返利

活动期间充值任意金额即可获得额外10%元宝返利，累计充值更有绝版坐骑赠送。

快叫上你的战友，一起参与夏日狂欢吧！`,
    category: 'xinwen',
    author: '征途运营团队',
    date: '2026-08-03',
    readTime: '3分钟',
    image: 'https://readdy.ai/api/search-image?query=Summer%20festival%20celebration%20Chinese%20MMORPG%20game%20event%20promotional%20art%2C%20festive%20Chinese%20characters%20in%20colorful%20summer%20costumes%2C%20beach%20and%20ancient%20Chinese%20architecture%20blend%2C%20warm%20golden%20sunset%20lighting%2C%20cheerful%20atmosphere%2C%20game%20illustration&width=800&height=450&seq=article-event-05&orientation=landscape',
  },
  {
    id: 6,
    slug: 'zhuangbei-fumo-jiasu-zhinan',
    title: '装备附魔与觉醒系统深度解析：最大化战力提升',
    excerpt: '随着V8.0版本装备觉醒系统的上线，装备养成体系更加丰富。本文详解附魔与觉醒的最佳组合方案，助你打造极品装备。',
    content: `装备养成是征途国际中最核心的战力提升途径。随着V8.0版本的装备觉醒系统上线，养成体系变得更加深度。

## 一、附魔系统

装备附魔是提升基础属性的主要方式。每件装备最多可附魔5条属性。推荐附魔优先级：

- 武器：攻击力 > 暴击率 > 暴击伤害 > 命中 > 其他
- 防具：生命值 > 防御力 > 减伤 > 闪避 > 其他
- 饰品：攻击力 > 暴击率 > 暴击伤害 > 生命值 > 其他

## 二、觉醒系统

觉醒是V8.0新增的装备强化方式。觉醒后的装备将获得独特的觉醒技能。每个部位的觉醒技能不同：

- 武器觉醒：攻击时有概率触发额外伤害
- 防具觉醒：受到攻击时有概率触发护盾
- 饰品觉醒：释放技能时有概率减少冷却时间

## 三、附魔与觉醒的协同

附魔和觉醒可以产生协同效果。例如，武器附魔暴击率+觉醒暴击触发额外伤害，可以形成强大的输出循环。

## 四、资源分配建议

优先觉醒武器，其次是防具，最后是饰品。觉醒石是稀缺资源，建议集中投入在核心装备上。`,
    category: 'gonglue',
    author: '战力研究院',
    date: '2026-08-01',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20MMORPG%20legendary%20weapon%20and%20armor%20display%2C%20glowing%20magical%20equipment%20with%20golden%20runes%20and%20crimson%20energy%20effects%2C%20dark%20background%20with%20dramatic%20spotlight%2C%20game%20item%20illustration%20style%2C%20high%20detail&width=800&height=450&seq=article-gear-06&orientation=landscape',
  },
  {
    id: 7,
    slug: 'hefu-gonggao-2026-q3',
    title: '征途国际2026年第三季度服务器合并公告',
    excerpt: '为了优化游戏体验，征途国际将于8月进行服务器合并。本次合服涉及多个服务器，请相关玩家提前做好准备。',
    content: `亲爱的征途国际玩家：

为了给大家带来更好的游戏体验，征途国际运营团队决定对部分服务器进行合并。

## 合服时间
2026年8月25日 02:00 - 10:00（预计8小时）

## 合服范围

**第一组**：
- 龙腾四海（主服）
- 剑指苍穹
- 铁血战歌

**第二组**：
- 王者归来（主服）
- 群雄逐鹿
- 纵横天下

## 合服规则

1. 角色保留：同一账号下最多保留3个等级最高的角色
2. 重名处理：合服后角色重名，系统将自动添加服务器后缀
3. 帮派处理：帮派名称重复的，将添加服务器后缀
4. 排行榜：合服后所有排行榜将重新排名
5. 拍卖行：合服前请及时领取拍卖行中的物品

## 合服补偿
合服完成后，所有受影响服务器的玩家将获得：
- 绑定元宝 × 500
- 经验丹 × 10
- 觉醒石 × 3
- 限定时装（7天）× 1

请各位玩家提前做好准备，如有疑问请联系客服。

征途国际运营团队
2026年8月1日`,
    category: 'gonggao',
    author: '征途运营团队',
    date: '2026-08-01',
    readTime: '3分钟',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20game%20server%20merge%20announcement%2C%20multiple%20ancient%20Chinese%20realms%20merging%20together%20in%20cosmic%20scene%2C%20dramatic%20golden%20energy%20converging%2C%20epic%20cinematic%20illustration%2C%20red%20and%20gold%20color%20scheme&width=800&height=450&seq=article-merge-07&orientation=landscape',
  },
  {
    id: 8,
    slug: 'kuafu-zhanchang-longcheng-zhengba-gonglue',
    title: '跨服战场「龙城争霸」全方位攻略：制胜之道',
    excerpt: 'V8.0版本重磅推出的跨服战场即将上线！提前掌握龙城争霸的玩法和战术，在新版本中抢占先机。',
    content: `跨服战场「龙城争霸」是V8.0版本的重头戏。这个全新的PVP玩法将打破服务器壁垒，让全服玩家同台竞技。

## 一、玩法概述

龙城争霸每周六晚20:00-21:00开启。所有服务器玩家可自由组队（5人一队）进入战场。战场中有一座龙城和四个外围据点。

## 二、得分机制

- 占领龙城：每秒获得10积分
- 占领外围据点：每个每秒获得3积分
- 击杀敌方玩家：每次获得5积分
- 比赛结束时积分最高的队伍获胜

## 三、战术要点

**时间分配**：
- 前10分钟：争夺外围据点，积累初期优势
- 中间30分钟：集中火力攻占龙城
- 最后20分钟：防守龙城，防止被反攻

**队伍配置建议**：
- 1名战士（前排肉盾）
- 1名法师（AOE输出）
- 1名弓手（单点爆发）
- 1名仙术（治疗辅助）
- 1名召唤（灵活补位）

## 四、奖励机制

- 冠军队伍：限定称号「龙城霸主」+ 觉醒石×10 + 限定坐骑
- 亚军队伍：觉醒石×5 + 稀有道具箱
- 季军队伍：觉醒石×3 + 道具箱
- 参与奖：觉醒石×1 + 经验丹`,
    category: 'gonglue',
    author: '征途攻略组',
    date: '2026-07-28',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20battlefield%20with%20floating%20dragon%20city%20in%20the%20sky%2C%20armies%20of%20armored%20warriors%20converging%20on%20ancient%20Chinese%20fortress%2C%20golden%20and%20crimson%20dramatic%20sky%2C%20cinematic%20war%20scene%2C%20game%20concept%20art&width=800&height=450&seq=article-cross-08&orientation=landscape',
  },
];

export const faqs = [
  {
    question: '征途国际是什么类型的游戏？',
    answer: '征途国际是一款经典热血国战MMORPG手游，以中国古代战国时期为背景，玩家可以选择不同职业，参与万人国战、帮派争霸、跨服战场等多种PVP玩法，体验激情热血的国战氛围。',
  },
  {
    question: '征途国际支持哪些平台？',
    answer: '征途国际全面支持Android安卓、iOS苹果以及PC电脑端三平台。您可以在本页面根据您的设备选择对应的下载入口，一键下载安装。',
  },
  {
    question: '征途国际是免费游戏吗？',
    answer: '是的，征途国际完全免费下载和游玩。游戏内提供丰富的免费内容，玩家可以通过完成任务、参与活动获得大量资源。同时游戏内也提供可选的内购项目，但不会影响游戏平衡性。',
  },
  {
    question: 'Android和iOS数据互通吗？',
    answer: '目前Android和iOS的服务器是独立的，两个平台的玩家暂时无法在同一个服务器中游戏。但官方正在积极筹备跨平台互通计划，敬请关注后续公告。',
  },
  {
    question: '游戏安装包有多大？对手机配置有什么要求？',
    answer: '征途国际安装包约2.5GB，建议预留5GB以上存储空间。推荐配置：Android 8.0以上、iOS 13以上、运行内存4GB以上。游戏经过深度优化，中低端设备也能流畅运行。',
  },
  {
    question: '下载安装后无法启动怎么办？',
    answer: '如遇到无法启动的问题，请尝试以下方法：1. 确认设备系统版本满足最低要求；2. 清理手机缓存并重启设备；3. 卸载后重新从官方渠道下载安装；4. 如仍无法解决，请联系官方客服获取技术支持。',
  },
  {
    question: '游戏内遇到BUG或需要客服帮助怎么联系？',
    answer: '您可以通过以下方式联系客服：1. 游戏内「设置-客服中心」提交工单；2. 发送邮件至官方客服邮箱 kefu@zhengtu.com；3. 关注官方微信公众号「征途国际」在线咨询。客服工作时间：每日9:00-21:00。',
  },
  {
    question: '如何保障账号安全？',
    answer: '建议您绑定手机号和邮箱，开启二级密码保护。不要将账号信息透露给他人，不要使用第三方非法辅助工具。如发现账号异常，请立即联系官方客服处理。',
  },
];